var App = App || {};

App.HomepageBanner = (function ($) {
    "use strict";

    function init() {

        const homepageBanner = $(".widget.widget-homepage-banner");
        if (homepageBanner.length) {
            homepageBanner.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(homepageBanner) {
        const mainCarousel = homepageBanner.find(".splide.main-carousel");
        if (mainCarousel.length) {
            const splideMainCarousel = new Splide(mainCarousel[0], {
                pagination: false,
                type: 'fade',
                rewind: true,
                fixedWidth: "100%",
                //gap: "30px",
                drag: false,
                snap: false,
                perPage: 1,
                perMove: 1
            });

            splideMainCarousel.mount();

            const nextBtn = homepageBanner.find(".carousel-btn.carousel-next");
            const prevBtn = homepageBanner.find(".carousel-btn.carousel-prev");

            nextBtn.on("click", function () {
                splideMainCarousel.go('+1')
            });

            prevBtn.on("click", function () {
                splideMainCarousel.go('-1')
            });

            const secondaryCarousel = homepageBanner.find(".splide.navigation-carousel");
            if (secondaryCarousel.length) {
                const splideSecondaryCarousel = new Splide(secondaryCarousel[0], {
                    pagination: false,
                    type: 'loop',
                    fixedWidth: "125px",
                    gap: "10px",
                    drag: false,
                    snap: false,
                    perMove: 1,
                    perPage: 1,
                    start: 1,
                    breakpoints: {
                        991: {
                            fixedWidth: "8.6rem",
                            gap: "15px",
                        },
                    }
                });

                splideSecondaryCarousel.mount();

                nextBtn.on("click", function () {
                    splideSecondaryCarousel.go('+1')
                });

                prevBtn.on("click", function () {
                    splideSecondaryCarousel.go('-1')
                });

                $("button.homepage-banner-nav-item").on("click", function () {
                    splideMainCarousel.go($(this).data("index"));
                    splideSecondaryCarousel.go($(this).data("index") + 1);
                });
            }
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.HomepageBanner.init();
});